<template>
  <el-dropdown trigger="click" @visible-change="dropDownIcon" @command="handleCommand">
    <span class="el-dropdown-link">
      {{ timeZone }}
      <i :class="textIcon" />
    </span>
    <el-dropdown-menu slot="dropdown" class="lang-dropdown">
      <el-dropdown-item v-for="zone in timeZoneList" :command="zone" :key="zone">{{ zone }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {
  mapMutations: userMapMutations
} = createNamespacedHelpers('user')

export default {
  name: 'timeZoneSwitch',
  data() {
    return {
      timeZone: 'UTC+8',
      textIcon: 'el-icon-arrow-down el-icon--right'
    }
  },
  computed: {
    timeZoneList() {
      const list = [ 'UTC+0', 'UTC+8', 'UTC+9', 'UTC-5', 'UTC-8']
      return list.filter(i => i !== this.timeZone)
    }
  },
  watch: {
    '$i18n.locale': {
      handler(lang) {
        this.timeZone = lang === 'zh'? 'UTC+8': 'UTC+0'
        this.setTimeZone(this.timeZone)
      },
      immediate: true
    }
  },
  created() {
    const timeZone = localStorage.getItem('pp-timeZone');
    if(timeZone) {
      this.timeZone = timeZone;
      this.setTimeZone(this.timeZone);
    }
  },
  methods: {
    ...userMapMutations(['setTimeZone']),
    dropDownIcon(val) {
      if (val) this.textIcon = 'el-icon-arrow-up el-icon--right'
      else this.textIcon = 'el-icon-arrow-down el-icon--right'
    },
    handleCommand(val) {
      this.timeZone = val
      localStorage.setItem('pp-timeZone', val)
      setTimeout(() => {
        window.location.reload()
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-popper {
    margin-top: 3px;
}
.el-dropdown {
  margin-right: 20px;
}
.el-dropdown-link {
	cursor: pointer;
  font-size: 16px;
  color: #666;
}
.mgr5 {
    margin-right: 3px;
}
.lang-dropdown {
    padding: 1px;
}
</style>
